import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Shared concierge card used in both Birthday and Discover modes.
 * Renders a contextual action card with icon, title, subtitle, and optional badge.
 */
export default function ConciergeCard({ icon: Icon, title, subtitle, to, badge, accentColor, delay = 0, testId }) {
  const navigate = useNavigate();

  return (
    <motion.button
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      whileTap={{ scale: 0.97 }}
      onClick={() => navigate(to)}
      className="relative w-full flex items-center gap-3 p-4 rounded-2xl bg-white border border-slate-100 shadow-[0_1px_3px_rgba(0,0,0,0.03),0_4px_12px_rgba(0,0,0,0.05)] text-left group hover:shadow-md transition-shadow"
      data-testid={testId}
    >
      <div
        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: `${accentColor || "#0ea5e9"}15` }}
      >
        <Icon className="w-5 h-5" style={{ color: accentColor || "#0ea5e9" }} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-bold text-slate-800 leading-tight">{title}</h3>
          {badge && (
            <span
              className="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
              style={{ backgroundColor: `${accentColor || "#0ea5e9"}15`, color: accentColor || "#0ea5e9" }}
            >
              {badge}
            </span>
          )}
        </div>
        <p className="text-xs text-slate-400 mt-0.5 truncate">{subtitle}</p>
      </div>
      <ChevronRight className="w-4 h-4 text-slate-300 group-hover:text-slate-400 transition-colors flex-shrink-0" />
    </motion.button>
  );
}
